<mat-list-item *ngIf="appointment$ | ngrxPush as appointment">
  <mat-icon matListItemIcon>people</mat-icon>
  <span matListItemTitle>{{ appointment.practitioner.name }}</span>
  <span matListItemLine>Practitioner</span>
</mat-list-item>
